import { takePostAuth } from "@/lib/askThemes";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { LogoMark } from "@/components/Logo";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";

export default function NameSetup() {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const { refreshUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    try {
      await api.patch("/auth/profile", { name: name.trim() });
      await refreshUser();
      navigate(takePostAuth() || "/activate", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="debii-shell flex flex-col px-6 py-12">
      <div className="flex-1 flex flex-col justify-center max-w-sm w-full mx-auto">
        <LogoMark size={56} />
        <h1 className="mt-6 font-display text-3xl font-extrabold text-foreground">What should we call you?</h1>
        <p className="mt-2 text-sm text-muted-foreground">Just your first name — it keeps things personal.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <Input
            data-testid="setup-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="First name"
            className="h-14 rounded-xl text-lg"
            autoFocus
          />
          <Button data-testid="setup-name-continue" type="submit" disabled={loading || !name.trim()} className="w-full h-12 rounded-xl text-base">
            {loading ? "Saving…" : "Continue"}
          </Button>
        </form>
      </div>
    </div>
  );
}
